import React from 'react';
import { DisabledPrompt, useModel } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from 'components/shared';
import { SVGAsset } from 'res';
import { getScheduledDescription } from '../..';


/**
 * @function ScheduledWireTableRow
 * @returns {React.Component}
 * @exported false
 * @description 
 */
export function ScheduledWireTableRow(props) {
    const scheduledWire = props.scheduledWire ?? {};
    const { branding } = useModel() ?? {};
    const { options } = branding ?? {};
    const notifyPayee = scheduledWire.notifyPayee ? "Yes" : "No";
    const hasNotifyPayeeColumn = options.scheduled_wires_notify_payee_abi22 === "true";
    const scheduledDescription = getScheduledDescription(scheduledWire);
    const rowId = props.rowId ?? "";

    return (
        <TableItemContainer>
            <TableItemTextView text={scheduledWire.referenceNumber} />
            <TableItemTextView text={scheduledWire.payeeName} />
            {hasNotifyPayeeColumn && <TableItemTextView text={notifyPayee} />}
            <TableItemTextView text={scheduledDescription} />
            <TableItemTextView text={scheduledWire.amount.format()} />
            <TableItemTextView text={scheduledWire.futureWireDate.format("m/d/Y")} />
            <TableItemView className="wire-activity-table-row-icons text-right">
                <DisabledPrompt>
                    <SVGAsset id="MagnifyingGlassIcon" className="clickable" data-point={`Scheduled_Wire_Details_${rowId}`} />
                </DisabledPrompt>
                <DisabledPrompt>
                    <SVGAsset id="TrashcanXIcon" className="trash-can-x-icon clickable" data-point={`Scheduled_Wire_Delete_${rowId}`} />
                </DisabledPrompt>
            </TableItemView>
        </TableItemContainer>
    );
}

